import { callTypeConfig } from "@/playground/components/DevHome/table/states/columns/call_type/call_type";
import { customerConfig } from "@/playground/components/DevHome/table/states/columns/customer/customer";
import { dateConfig } from "@/playground/components/DevHome/table/states/columns/date/date";
import { durationConfig } from "@/playground/components/DevHome/table/states/columns/duration/duration";
import { numberConfig } from "@/playground/components/DevHome/table/states/columns/number/number";
import { transcriptConfig } from "@/playground/components/DevHome/table/states/columns/transcript/transcript";
import { userConfig } from "@/playground/components/DevHome/table/states/columns/user/user";
import type {
  ColumnType,
  PickColumnsProps,
  TrackerColumnType,
} from "./columns.decl";
import { csatConfig } from "./csat/csat";
import { previewConfig } from "./preview/preview";
import { resultsCountConfig } from "./results_count/results_count";
import { sentimentConfig } from "./sentiment/sentiment";
import { userWithVirtualAgentsConfig } from "./user_with_virtual_agents/user_with_virtual_agents";

export function pickColumns({
  isSearchTriggered,
  hasSentimentAnalysisFeature,
  hasCsatFeature,
}: PickColumnsProps): ColumnType[] {
  return [
    callTypeConfig,
    userWithVirtualAgentsConfig,
    numberConfig,
    customerConfig,
    durationConfig,
    dateConfig,
    ...(isSearchTriggered ? [] : [transcriptConfig]),
    ...(isSearchTriggered ? [resultsCountConfig] : []),
    ...(hasSentimentAnalysisFeature ? [sentimentConfig] : []),
    ...(hasCsatFeature ? [csatConfig] : []),
    previewConfig,
  ];
}

// Not good assertion, we need to refactor some typing to be able to share the table columns types.
export const trackerColumns = [
  callTypeConfig,
  userConfig,
  numberConfig,
  customerConfig,
  durationConfig,
  dateConfig,
  sentimentConfig,
  previewConfig,
] as TrackerColumnType[];
